import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { AuthProvider } from './auth/AuthProvider'
import App from './App'
import './index.css'
import i18n from './i18n'
import { initObservability } from './sentry'

const el = document.getElementById('root')
if (!el) throw new Error('Missing #root element in index.html')

ReactDOM.createRoot(el).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
)

initObservability()
